const theme = {
  envTitleColor: Styles.color.grey.one,
};

export default theme;
